<template>
	<div>
		<v-card v-for="group in groupedDates" :key="group" elevation="0" outlined class="mr-1 mt-2 pt-2 pb-2 pl-1 pr-1" style="border-radius: 8px; !important">
			<v-row no-gutters align="center" justify="left">
				<span style="font-family: Montserrat; font-style: normal; font-weight: 500; font-size: 12px; line-height: 15px"
					>{{ dateFormatted(group[0]) }} to {{ dateFormatted(group[group.length - 1]) }}</span
				>
			</v-row>
		</v-card>
	</div>
</template>

<script>
import moment from 'moment';
export default {
	name: 'CalendarDateStripSmartGroup',
	props: ['dates'],
	data: () => ({
		default_date: '1990-01-01',
	}),
	computed: {
		groupedDates() {
			let grouping = this.dates.reduce((prev, curr, index) => {
				if (index == 1) {
					if (moment(prev).add(1, 'days').isSame(curr)) {
						return [[prev, curr]];
					} else {
						return [[prev], [curr]];
					}
				} else {
					let latest = prev.pop();
					let latestDate = latest[latest.length - 1];
					if (moment(latestDate).add(1, 'days').isSame(curr)) {
						latest.push(curr);
						return [...prev, latest];
					} else {
						return [...prev, latest, [curr]];
					}
				}
			});

			return grouping;
		},
	},
	mounted() {},
	methods: {
		dateFormatted(date) {
			return moment(date ? date : this.default_date).format('MMM DD YYYY');
		},
		click(a) {
			this.$emit('click', this.date);
			// MouseEvent.prototype.
			a.stopPropagation();
		},
	},
};
</script>
